import { css } from 'linaria';

export const subtitleTopLineContainer = css`
  width: 100%;
  display: flex;
  margin-bottom: var(--space-60);
`;

export const subtitleText = css`
  color: var(--secondary-black_opacity-4);
  border: 1px solid var(--control-secondary_opacity-4);
  border-radius: var(--rounding-s);
  padding: var(--space-10) var(--space-60);
  background-color: var(--secondary-white_opacity-4);
  margin-bottom: var(--space-25);
`;
